import React from "react";
import {
  VegaBox,
  VegaFlex,
  VegaFont,
  VegaIcon,
} from "@heartlandone/vega-react";

const ActivityScore = ({ score }) => {
  const displayScore =
    typeof score === "number" && score.toString().includes(".")
      ? score.toFixed(1)
      : score;
  return (
    <VegaBox
      border={"border-chip"}
      backgroundColor="bg-primary"
      corners="rounded-full"
      style={{
        padding: "3px 8px",
      }}
    >
      <VegaFlex alignItems="center" gap={"size-4"}>
        <VegaIcon
          icon="fa-solid fa-star"
          color="text-accent3-primary"
          size="size-12"
        ></VegaIcon>
        <VegaFont variant="font-field-label-sm">{displayScore}</VegaFont>
      </VegaFlex>
    </VegaBox>
  );
};

export default ActivityScore;
